import React from 'react';
import { connect } from 'react-redux'
import getEventInfo from '../../../actions/events/getEventInfoAction'
import EventsCalendar from "./eventsCalendar.component";
import getEventSongs from '../../../actions/events/getEventSongsAction'
import keepCalendarViewState from '../../../actions/events/keepCalendarViewStateAction'
import keepCalendarDateState from '../../../actions/events/keepCalendarDateStateAction'


class EventsCalendarContainer extends React.Component {

   handleEventSelected(event) {
      this.props.getEventInfo(event.objectId);
   }

   render() {
      return (
         <EventsCalendar
            data={this.props.data}
            handleEventSelected={this.handleEventSelected.bind(this)}
            keepCalendarViewState = {this.props.keepCalendarViewState}
            keepCalendarDateState = {this.props.keepCalendarDateState}
            date = {this.props.date}
            view = {this.props.view}
         />
      );
   }
}

const mapStateToProps = (state) => {
   return {
      data: state.events.data,
      date: state.view.calendarDate,
      view: state.view.calendarViewType,
   };
}

const mapDispatchToProps = {
   getEventInfo: getEventInfo,
   getEventSongs: getEventSongs,
   keepCalendarDateState: keepCalendarDateState,
   keepCalendarViewState: keepCalendarViewState,
}


export default connect(
   mapStateToProps, mapDispatchToProps
)(EventsCalendarContainer)



// WEBPACK FOOTER //
// ./src/pages/myEvents/eventsCalendar/eventsCalendar.container.js